var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from "@angular/core";
import { XHRBackend, ResponseOptions, XSRFStrategy } from "@angular/http";
import { ProgressBrowserXhrFactory } from "./ProgressBrowserXhrFactory";
var XHRBackendFactory = (function () {
    function XHRBackendFactory(responseOptions, xsrfStrategy, progressBrowserXhrFactory) {
        this.responseOptions = responseOptions;
        this.xsrfStrategy = xsrfStrategy;
        this.progressBrowserXhrFactory = progressBrowserXhrFactory;
    }
    XHRBackendFactory.prototype.create = function (upload, download) {
        var progressBrowserXhr = this.progressBrowserXhrFactory.create(upload, download);
        return new XHRBackend(progressBrowserXhr, this.responseOptions, this.xsrfStrategy);
    };
    return XHRBackendFactory;
}());
XHRBackendFactory = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ResponseOptions,
        XSRFStrategy,
        ProgressBrowserXhrFactory])
], XHRBackendFactory);
export { XHRBackendFactory };
//# sourceMappingURL=XHRBackendFactory.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-progress-http/lib/XHRBackendFactory.js
// module id = 539
// module chunks = 3